
div
  .panel.panel-default.card(:style="{borderColor: color}")
    .panel-heading(:style="{backgroundColor: color}")
      | {{satisfaction("score")}} {{title}}
      i.fa.fa-3x.pull-right.card-icon(v-bind:class='icon')
    .panel-body.card-body
      slot
      i.fa.fa-spinner.fa-spin.fa-4x.card-spinner(v-if="loading && !custom")
      div(v-else-if='!custom')
        .rating-box(:style="{color: color}" v-if='score > 0')
          .rating(:style="{color: color, width: width('score')}")
        .scale-score(v-if='score > 0' :style="{color: color}") {{score_value("score")}}
        .scale-score(v-else style='font-size: 1.2em; line-height: 2.5em'): i
          | {{$t('js.award.no_data')}}
        .scale-title {{subtitle}}
        .full_time.text-muted(v-if='full_time > 0')
          .rating-box.full-time-rating
            .rating(:style="{width: width('full_time')}")
          | {{ $t('js.award.full_time', {count: score_value("full_time")}) }}
